import React, { useState } from 'react';
import { VENUE_STYLES } from '../data/venueData';

const getLocalizedVenueStyles = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const isSpanish = browserLang.startsWith('es');
  
  return VENUE_STYLES.map(style => ({
    ...style,
    label: isSpanish ? style.labelEs : style.label
  }));
};

export default function BudgetHeader({ guestCount, style, onGuestCountChange, onStyleChange }) {
  const localizedStyles = getLocalizedVenueStyles();
  const [isGuestFocused, setIsGuestFocused] = useState(false);
  const [inputValue, setInputValue] = useState(guestCount.toString());

  const handleGuestInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    const numValue = parseInt(value);
    if (!isNaN(numValue)) {
      onGuestCountChange(Math.max(20, Math.min(200, numValue)));
    }
  };

  const handleGuestInputBlur = () => {
    setIsGuestFocused(false);
    setInputValue(guestCount.toString());
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="bg-white rounded-2xl p-6 border border-[#ececec] hover:border-[#bfa76a] transition-colors">
        <div className="flex items-center justify-between mb-4">
          <label className="text-base font-medium text-[#181c24]">
            Number of Guests
          </label>
          <span className="text-sm text-[#888]">20-200 guests</span>
        </div>
        
        <div className="flex items-center gap-3">
          <button
            onClick={() => {
              const newValue = Math.max(20, guestCount - 10);
              onGuestCountChange(newValue);
              setInputValue(newValue.toString());
            }}
            className="w-8 h-8 rounded-full bg-[#f7f7f7] text-[#181c24] hover:bg-[#ececec] active:bg-[#e0e0e0] transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={guestCount <= 20}
          >
            -
          </button>
          
          <div className={`flex-1 relative ${isGuestFocused ? 'ring-2 ring-[#bfa76a]' : ''} rounded-lg transition-all`}>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={inputValue}
              onChange={handleGuestInputChange}
              onFocus={() => setIsGuestFocused(true)}
              onBlur={handleGuestInputBlur}
              className="w-full text-2xl font-medium text-[#181c24] text-center bg-transparent focus:outline-none"
            />
          </div>

          <button
            onClick={() => {
              const newValue = Math.min(200, guestCount + 10);
              onGuestCountChange(newValue);
              setInputValue(newValue.toString());
            }}
            className="w-8 h-8 rounded-full bg-[#f7f7f7] text-[#181c24] hover:bg-[#ececec] active:bg-[#e0e0e0] transition-colors flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={guestCount >= 200}
          >
            +
          </button>
        </div>
      </div>

      <div className="bg-white rounded-2xl p-6 border border-[#ececec] hover:border-[#bfa76a] transition-colors">
        <div className="flex items-center justify-between mb-4">
          <label className="text-base font-medium text-[#181c24]">
            Venue Style
          </label>
          <span className="text-sm text-[#888]">Select your preference</span>
        </div>

        <div className="relative">
          <select
            value={style}
            onChange={(e) => onStyleChange(e.target.value)}
            className="w-full p-3 rounded-xl border border-[#ececec] bg-white text-[#181c24] focus:outline-none focus:ring-2 focus:ring-[#bfa76a] focus:border-transparent appearance-none cursor-pointer"
          >
            {localizedStyles.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <svg className="w-5 h-5 text-[#888]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
} 